module.exports = __webpack_public_path__ + "img/game1.58aec049.png";